import _ from 'lodash';

/**
 * Unified root grid: rootOrder interleaves categories and standalone cards.
 * Rebuilds categories[] and standalone[] order to match rootOrder.
 */
export function ensureHospitalRootOrder(layout) {
	if (!layout) return layout;
	const categories = layout.categories || [];
	const standalone = layout.standalone || [];
	const catById = _.keyBy(categories, 'id');
	const standById = _.keyBy(standalone, 'id');

	let order =
		Array.isArray(layout.rootOrder) && layout.rootOrder.length > 0 ? [...layout.rootOrder] : [];

	if (order.length === 0) {
		order = [
			...categories.map((c, i) => ({
				id: c.id,
				type: 'category',
				width: 12,
				position: i,
			})),
			...standalone.map((c, i) => ({
				id: c.id,
				type: 'card',
				width: c.width || 4,
				position: categories.length + i,
			})),
		];
	} else {
		order = order.filter((e) => catById[e.id] || standById[e.id]);
		const seen = new Set(order.map((o) => o.id));
		categories.forEach((c) => {
			if (!seen.has(c.id)) {
				order.push({ id: c.id, type: 'category', width: 12, position: order.length });
				seen.add(c.id);
			}
		});
		standalone.forEach((s) => {
			if (!seen.has(s.id)) {
				order.push({
					id: s.id,
					type: 'card',
					width: s.width || 4,
					position: order.length,
				});
				seen.add(s.id);
			}
		});
	}

	order = order.map((e, i) => ({
		id: e.id,
		type: catById[e.id] ? 'category' : 'card',
		width: catById[e.id] ? 12 : standById[e.id]?.width || e.width || 4,
		position: i,
	}));

	const newCategories = [];
	const newStandalone = [];
	order.forEach((e) => {
		if (catById[e.id]) newCategories.push(catById[e.id]);
		else if (standById[e.id]) newStandalone.push(standById[e.id]);
	});

	return {
		...layout,
		version: layout.version || '3.0',
		rootOrder: order,
		categories: newCategories.map((c) => ({
			...c,
			gridH: c.gridH <= 12 ? c.gridH * 12 : c.gridH,
		})),
		standalone: newStandalone.map((s) => ({
			...s,
			gridH: s.gridH <= 8 ? s.gridH * 12 : s.gridH,
		})),
	};
}
